var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-container action-button"},[_c('button',{class:[_vm.state],attrs:{"aria-label":"scroll to top"}},[_c('Icon',{attrs:{"name":_vm.iconName,"custom-css":_vm.customCss}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }